/* Colourway swatches — keep the selected size when switching colour.
   Each swatch link carries data-sizes='{"41":123,"42":124}' (available variants
   of that sibling). When the shopper picks a size we point every swatch at the
   matching ?variant= so the size survives the jump to the sibling product. */
(function () {
  var SIZE_RE = /size|größe/i;

  function currentSize() {
    var opts = document.querySelectorAll('[data-swatch-option]');
    for (var i = 0; i < opts.length; i++) {
      var title = opts[i].querySelector('.t4s-swatch__title');
      if (!title || !SIZE_RE.test(title.textContent)) continue;
      var sel = opts[i].querySelector('[data-swatch-item].is--selected');
      if (sel) return sel.getAttribute('data-value');
      var cur = opts[i].querySelector('[data-current-value]');
      return cur ? cur.textContent.trim() : '';
    }
    return '';
  }

  function sync() {
    var size = currentSize();
    var links = document.querySelectorAll('.t4s-cg__item[data-sizes]');
    for (var i = 0; i < links.length; i++) {
      var a = links[i];
      var base = a.getAttribute('data-url');
      if (!base) continue;
      var map;
      try { map = JSON.parse(a.getAttribute('data-sizes')); } catch (e) { continue; }
      a.setAttribute('href', size && map[size] ? base + '?variant=' + map[size] : base);
    }
  }

  // Size pills are plain divs updated by the theme; re-sync just after a click.
  document.addEventListener('click', function (e) {
    if (!e.target.closest) return;
    if (e.target.closest('[data-swatch-item]')) setTimeout(sync, 0);
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', sync);
  } else {
    sync();
  }
})();
